module.exports = __webpack_public_path__ + "img/niu14.4996d476.jpg";